import React from 'react';

import {

  SwapVert,
  ErrorOutlined,
  ViewList,
  People,
  Folder,
  SupervisedUserCircleRounded,
} from '@material-ui/icons';

/**
 * Displays an icon corresponding the resource property
 */
export default ({resource, ...props}) => {
  switch(resource.id) {
    case 'shared_folders': 
      return <Folder {...props} />
    case 'shared_guests':
      return <People {...props} />
    case 'shared_bytes':
      return <SwapVert {...props} />
    case 'forms':
      return <ViewList {...props} />
    case 'owners':
      return <SupervisedUserCircleRounded {...props} />
    default:
      return <ErrorOutlined {...props} />
  }
}


// WEBPACK FOOTER //
// ./src/components/resources/ResourceIcon.js